"use strict";

exports.__esModule = true;
exports.default = contains;
var _isArrayLike = _interopRequireDefault(require("./_isArrayLike.js"));
var _values = _interopRequireDefault(require("./values.js"));
var _indexOf = _interopRequireDefault(require("./indexOf.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Determine if the array or object contains a given item (using `===`).
function contains(obj, item, fromIndex, guard) {
  if (!(0, _isArrayLike.default)(obj)) obj = (0, _values.default)(obj);
  if (typeof fromIndex != 'number' || guard) fromIndex = 0;
  return (0, _indexOf.default)(obj, item, fromIndex) >= 0;
}